import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VDataTable, {
    attrs: {
      "items": _vm.ips,
      "options": _vm.tableOptions,
      "headers": _vm.tableHeaders,
      "loading": _vm.isFetching,
      "footer-props": _vm.tableFooterProps,
      "item-key": "id"
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(items.item))]), _vm.isIotHubManager ? _c('td', {
          staticClass: "text-right"
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": "",
            "title": "Delete"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteLine(items.item);
            }
          }
        }, [_vm._v("fal fa-trash-alt")]), _vm._v("\n           \n          "), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": "",
            "title": "Edit"
          },
          on: {
            "click": function ($event) {
              return _vm.editItem(items.item);
            }
          }
        }, [_vm._v("fal fa-edit")])], 1) : _vm._e()])];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_vm._v("\n      " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n    ")];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n      ")])];
      },
      proxy: true
    }])
  }), _c(VDialog, {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: _vm.dialogAdd,
      callback: function ($$v) {
        _vm.dialogAdd = $$v;
      },
      expression: "dialogAdd"
    }
  }, [_c(VCard, [_c(VCardTitle, {
    staticClass: "text-h5"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.enterIpAddr')))]), _c(VCardText, [_c(VForm, {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.isValidIp,
      callback: function ($$v) {
        _vm.isValidIp = $$v;
      },
      expression: "isValidIp"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.cloading,
      "label": "IP Address",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "newIpAddress",
      "rules": _vm.ipRules,
      "required": ""
    },
    on: {
      "change": _vm.handleSubmit
    },
    model: {
      value: _vm.newIpAddress,
      callback: function ($$v) {
        _vm.newIpAddress = $$v;
      },
      expression: "newIpAddress"
    }
  })], 1)], 1), _c(VCardActions, [_c('core-button', {
    attrs: {
      "color": _vm.color
    },
    on: {
      "click": function ($event) {
        _vm.dialogAdd = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.cancel')) + "\n        ")]), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "type": "submit",
      "disabled": !_vm.isValidIp
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.ok')) + "\n        ")]), _c(VSpacer)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };